import axios from '@axios'

const PREFIX = '/configuracoes-apis'

export default {
  getConfiguracaoApi() {
    return axios.get(`${PREFIX}`)
  },

  addUpdateConfiguracaoApi(value) {
    return axios.post(`${PREFIX}`, value)
  },
}
